import { normalizeApeCode } from "@/lib/cat/mdm-map-company";
import { shouldShowCompanyRecap } from "@/lib/cat/mdm-recap-from-draft";
import type { Draft } from "@/prisma/generated/client";

export type CompanyCategoryBadgeLabel =
  | "DIRIGEANT"
  | "TRANSPORT_PERSONNES"
  | "AUTO_ECOLE"
  | "PROFESSION_LIBERALE"
  | "LOCATION_COURTE_DUREE";

export const SALE_TYPE_TAG_LABELS: Record<CompanyCategoryBadgeLabel, string> = {
  DIRIGEANT: "DIRIGEANT",
  TRANSPORT_PERSONNES: "TRANSPORT_PERSONNES",
  AUTO_ECOLE: "AUTO_ECOLE",
  PROFESSION_LIBERALE: "PROFESSION_LIBERALE",
  LOCATION_COURTE_DUREE: "LOCATION_COURTE_DUREE",
};

export function formatSaleTypeTagLabel(tag: CompanyCategoryBadgeLabel): string {
  return SALE_TYPE_TAG_LABELS[tag];
}

export function resolveSaleTypeTags(
  draft: Draft | null,
): CompanyCategoryBadgeLabel[] | null {
  if (!shouldShowCompanyRecap(draft) || !draft) return null;
  const tags: CompanyCategoryBadgeLabel[] = [];
  if (draft.directorSale) tags.push("DIRIGEANT");

  const ape = normalizeApeCode(draft.companyApeCode);
  if (!ape) return tags;

  if (ape === "4932Z") tags.push("TRANSPORT_PERSONNES");
  if (ape === "8553Z") tags.push("AUTO_ECOLE");
  if (ape === "9609Z") tags.push("PROFESSION_LIBERALE");
  if (ape === "7711X") tags.push("LOCATION_COURTE_DUREE");

  return tags;
}
